var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEasyLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-easy-login_svg__a",
    width: "103.5%",
    height: "107%",
    x: "-1.7%",
    y: "-1.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    values: "0 0 0 0 0.769729393 0 0 0 0 0.10215635 0 0 0 0 0.10215635 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-easy-login_svg__d",
    width: "169.2%",
    height: "165.9%",
    x: "-34.6%",
    y: "-32.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.491593071 0 0 0 0 0.112491257 0 0 0 0 0.112491257 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "icon-easy-login_svg__e",
    width: "103.5%",
    height: "107%",
    x: "-1.7%",
    y: "-1.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowOffsetOuter1",
    values: "0 0 0 0 0.182576195 0 0 0 0 0.435828764 0 0 0 0 0.783514493 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon-easy-login_svg__h",
    width: "169.2%",
    height: "173%",
    x: "-34.6%",
    y: "-36.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.106115631 0 0 0 0 0.0926320146 0 0 0 0 0.563632246 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-easy-login_svg__c",
    x1: "50%",
    x2: "50%",
    y1: "2.206%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F74B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ED3A25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-easy-login_svg__g",
    x1: "50%",
    x2: "50%",
    y1: "2.206%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#78D8FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5091E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon-easy-login_svg__i",
    x1: "21.324%",
    x2: "64.632%",
    y1: "50%",
    y2: "64.772%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.237%",
    stopColor: "#FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icon-easy-login_svg__b",
    d: "M31.497.001L53.951 0c11.144 0 15.185 1.16 19.26 3.34 4.074 2.178 7.271 5.375 9.45 9.45l.214.407C84.915 17.141 86 21.276 86 32.049V53.95c0 11.144-1.16 15.185-3.34 19.26-2.178 4.074-5.375 7.271-9.45 9.45l-.407.214C68.859 84.915 64.724 86 53.951 86H32.05c-11.144 0-15.185-1.16-19.26-3.34-4.074-2.178-7.271-5.375-9.45-9.45l-.214-.407C1.119 68.927.038 64.866 0 54.503V32.049c0-11.144 1.16-15.185 3.34-19.26 2.178-4.074 5.375-7.271 9.45-9.45l.407-.214C17.073 1.119 21.134.038 31.497 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-easy-login_svg__f",
    d: "M31.497.001L53.951 0c11.144 0 15.185 1.16 19.26 3.34 4.074 2.178 7.271 5.375 9.45 9.45l.214.407C84.915 17.141 86 21.276 86 32.049V53.95c0 11.144-1.16 15.185-3.34 19.26-2.178 4.074-5.375 7.271-9.45 9.45l-.407.214C68.859 84.915 64.724 86 53.951 86H32.05c-11.144 0-15.185-1.16-19.26-3.34-4.074-2.178-7.271-5.375-9.45-9.45l-.214-.407C1.119 68.927.038 64.866 0 54.503V32.049c0-11.144 1.16-15.185 3.34-19.26 2.178-4.074 5.375-7.271 9.45-9.45l.407-.214C17.073 1.119 21.134.038 31.497 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFEAAA",
    d: "M55.888 26.001c27.436-29.329 87.119-37.194 108.848-5.817 18.664 26.951 34.23 85.304-10.95 131.15-37.304 37.852-84.897 40.525-116 24.739C-8.492 152.583 6.296 79.015 55.888 26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6CD98",
    stroke: "#E6CD98",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M102.515 9.626l11.966 6.503-14.939 8.794 2.973-15.297z",
    opacity: 0.699
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43,
    cy: 160,
    r: 6,
    fill: "#FFC5B8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114 24)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#icon-easy-login_svg__a)",
    xlinkHref: "#icon-easy-login_svg__b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#icon-easy-login_svg__c)",
    xlinkHref: "#icon-easy-login_svg__b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    filter: "url(#icon-easy-login_svg__d)",
    transform: "translate(138 47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.536 39.537c4.095 0 7.22-3.079 7.22-7.115 0-2.277-.972-4.477-2.626-6.081L18.877 11.307a5.524 5.524 0 00-3.912-1.63c-2.888 0-5.146 2.226-5.146 5.072a5.41 5.41 0 001.654 3.855l10.764 10.61a.855.855 0 00.578.258c.55 0 2.047-1.475 2.047-2.018a.83.83 0 00-.262-.57L13.836 16.276c-.394-.414-.657-.958-.657-1.527 0-1.01.762-1.734 1.76-1.734.577 0 1.155.233 1.575.621L31.767 28.67c.998.983 1.654 2.328 1.654 3.752 0 2.199-1.654 3.83-3.885 3.83-1.418 0-2.81-.648-3.807-1.631L5.356 14.516c-1.26-1.242-1.996-2.924-1.996-4.683 0-3.649 2.888-6.624 6.616-6.624 1.786 0 3.492.776 4.752 1.992l15.91 15.706a.864.864 0 00.604.259c.551 0 2.022-1.45 2.022-1.992a.827.827 0 00-.263-.57L17.118 2.924A10.301 10.301 0 009.95 0C4.384 0 0 4.373 0 9.858c0 2.614 1.103 5.15 2.967 7.013L23.366 36.95c1.628 1.604 3.86 2.587 6.17 2.587z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 24)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#icon-easy-login_svg__e)",
    xlinkHref: "#icon-easy-login_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#icon-easy-login_svg__g)",
    xlinkHref: "#icon-easy-login_svg__f"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    filter: "url(#icon-easy-login_svg__h)",
    transform: "translate(31 49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.274 18.682c1.824 0 3.792.759 5.907 2.276a20.738 20.738 0 015.307 5.536c1.42 2.171 2.129 4.15 2.129 5.94 0 .718-.131 1.312-.395 1.788a2.419 2.419 0 01-1.122 1.05 5.779 5.779 0 01-1.493.467c-.512.086-1.1.13-1.762.13-1.05 0-2.498-.352-4.343-1.052-1.847-.701-3.255-1.05-4.228-1.05-1.02 0-2.505.344-4.46 1.038-1.952.694-3.5 1.038-4.643 1.038-2.826 0-4.242-1.135-4.242-3.408 0-1.34.434-2.829 1.299-4.473a19.97 19.97 0 013.232-4.493 18.984 18.984 0 014.345-3.41c1.604-.919 3.095-1.377 4.469-1.377zM3.73 11.326c1.175 0 2.267.432 3.279 1.297a8.643 8.643 0 012.326 3.13c.543 1.22.812 2.406.812 3.56 0 1.244-.326 2.327-.973 3.245-.647.918-1.569 1.378-2.755 1.378-1.175 0-2.267-.432-3.28-1.295a8.818 8.818 0 01-2.33-3.117C.272 18.307 0 17.126 0 15.972c0-1.244.326-2.329.975-3.256.647-.928 1.565-1.39 2.755-1.39zm31.087 0c1.189 0 2.109.464 2.758 1.389.647.927.973 2.012.973 3.258 0 1.152-.271 2.334-.813 3.55a8.711 8.711 0 01-2.326 3.117c-1.014.865-2.103 1.295-3.278 1.295-1.19 0-2.108-.458-2.755-1.378-.65-.918-.975-1.998-.975-3.244 0-1.154.27-2.34.81-3.562a8.712 8.712 0 012.328-3.128c1.014-.865 2.104-1.298 3.278-1.298zM12.046 0c1.19 0 2.26.449 3.21 1.341a8.47 8.47 0 012.119 3.155c.463 1.207.695 2.384.695 3.535a7.91 7.91 0 01-.44 2.65 5.163 5.163 0 01-1.46 2.163c-.68.606-1.49.91-2.431.91-1.175 0-2.242-.448-3.198-1.343A8.365 8.365 0 018.41 9.248c-.464-1.217-.693-2.391-.693-3.527a7.9 7.9 0 01.438-2.65A5.166 5.166 0 019.614.911c.681-.608 1.491-.91 2.432-.91zM26.5 0c.943 0 1.755.305 2.432.911a5.179 5.179 0 011.459 2.16c.294.833.443 1.718.443 2.65 0 1.138-.232 2.313-.695 3.527a8.353 8.353 0 01-2.134 3.163c-.957.897-2.023 1.344-3.196 1.344-.942 0-1.752-.303-2.431-.911a5.164 5.164 0 01-1.462-2.16 7.926 7.926 0 01-.438-2.65c0-1.152.23-2.331.695-3.539.464-1.204 1.168-2.256 2.118-3.151S25.31 0 26.502 0z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#icon-easy-login_svg__i)",
    strokeWidth: 2,
    d: "M60.86 18c13.082.041 17.931 1.413 22.81 4.022 4.875 2.608 8.7 6.433 11.302 11.299C97.702 38.567 99 43.59 99 56.74h0v23.52c0 13.535-1.374 18.457-4.022 23.41-2.608 4.875-6.433 8.7-11.299 11.302-5.246 2.73-10.27 4.028-23.42 4.028h0H39.74c-13.535 0-18.457-1.374-23.41-4.022-4.875-2.608-8.7-6.433-11.302-11.299C2.336 98.507 1.04 93.563 1 80.855h0V56.14c.041-13.082 1.413-17.931 4.022-22.81 2.608-4.875 6.433-8.7 11.299-11.302C21.493 19.336 26.437 18.04 39.145 18h0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6F5FC2",
    d: "M139.722 124.22c-4.598-4.93-11.26-7.567-14.96-8.732 2.482 2.189 5.732 5.441 7.17 8.546a.613.613 0 01-.667.86.616.616 0 01-.453-.348c-1.827-3.947-7.007-8.336-9.093-10-1.222-.742-5.938-3.398-10.125-2.976 1.545 2.054 4.514 6.355 5.09 9.765a.512.512 0 01-.596.588.512.512 0 01-.416-.42c-.596-3.527-4.107-8.304-5.358-9.916-2.19-1.622-4.177-2.22-5.355-2.436.512 2.11 1.533 6.454 2.083 9.713a.511.511 0 01-.596.587.514.514 0 01-.417-.418c-.578-3.43-1.687-8.088-2.156-10.008h-.029S101.74 100.17 98.6 97.11c-3.14-3.06-21.6-14.8-23.292-15.098-1.692-.298-6.518 5.022.17 11.021 6.685 6 12.092 8.303 12.899 9.216.806.914 6.674 22.389 5.675 27.997-1 5.61-4.84 9.753-10.833 6.383-5.992-3.37-6.648-12.742-11.7-15.946-5.052-3.205-6.701-1.567-6.503.588.197 2.157 10.7 36.79 19.837 48.62 9.138 11.831 25.73 22.084 25.73 22.084s26.905 20.94 40.417-4.832c0 0-6.596-57.905-11.278-62.923"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5442AD",
    d: "M151 187.143s-.923-8.098-2.322-18.5c-.014.12-.033.235-.045.356-1.521 15.062-9.394 20.984-21.23 20.795-14.318-.23-39.069-17.574-46.967-32.85-13.747-26.582 23.188-7.182 20.15-26.786-1.059-6.82-9.212-26.355-10.223-28.846-1.01-2.492-9.691-7.928-13.703-11.528-2.736-2.454-.566-5.12 1.092-6.567-1.25-.706-2.132-1.15-2.444-1.205-1.692-.298-6.518 5.022.169 11.021 6.687 6 12.093 8.303 12.9 9.216.806.914 6.674 22.389 5.675 27.997-1 5.61-4.841 9.753-10.833 6.383s-6.648-12.742-11.7-15.946c-5.052-3.205-6.7-1.567-6.503.588.197 2.157 10.7 36.79 19.837 48.62 9.138 11.831 25.731 22.084 25.731 22.084s26.904 20.94 40.416-4.832",
    opacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79E4E4",
    fillRule: "nonzero",
    stroke: "#89C9C9",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M36.99 134.58l.685.943c-1.344.976-1.465 2.289-1.548 3.789l-.074.69c-.168 1.46-.488 3.03-2.253 4.313-1.835 1.333-3.457 1.122-4.961.786l-1.072-.243c-1.268-.278-2.35-.429-3.526.425-1.343.976-1.465 2.289-1.547 3.789l-.096.866c-.174 1.41-.537 2.906-2.232 4.137-2.047 1.487-3.828 1.053-5.477.667l-.582-.127c-1.206-.253-2.275-.368-3.332.314l-.167.114c-.384.279-.777.276-.982-.006-.206-.283-.087-.658.297-.936 2.047-1.488 3.828-1.054 5.477-.668l.582.128c1.27.266 2.387.38 3.5-.429 1.343-.976 1.465-2.288 1.547-3.789l.075-.69c.167-1.46.488-3.03 2.252-4.312 1.906-1.385 3.582-1.104 5.135-.748l.343.08c1.516.339 2.802.629 4.081-.3 1.343-.977 1.465-2.29 1.548-3.79l.074-.69c.161-1.401.463-2.905 2.048-4.157l.205-.155z",
    opacity: 0.553
  }))));
}

export default __webpack_public_path__ + "a725d65bd12216ef0663902a875e844d.svg";
export { SvgIconEasyLogin as ReactComponent };